<template name = "dateTemplate" lang="html">
	<div class="row">
		<b-loading :is-full-page="isFullPage" :active.sync="isLoading" :can-cancel="true"></b-loading>

		<div id="sidebarMenu" class="sidebar sidebar-fixed bg-white">
			<div class="sidebar-header">
				<h5>Search</h5>
				<a href="" id="sidebarMenuClose"><i data-feather="x"></i></a>
			</div><!-- df-sidebar-header -->
			<div class="sidebar-body">
				<ul class="sidebar-nav" v-for="(form, i) in inputSearchForms " v-if="form.division === 'C'">
					<li class="nav-label mg-b-10-f" v-if="i === 0">&nbsp;</li>
					<div class="form-group">
						<label :for="form.id" class="d-block has-text-weight-semibold">{{form.name}}</label>
            <p class="mg-b-0 text-left">{{orderData[form.id]}}</p>
						<!-- <input type="email" class="form-control" :name="form.id" v-model.lazy="orderData[form.id]" :id="form.id" :placeholder="form.name"> -->
					</div>
				</ul>
				<ul class="sidebar-nav" v-else-if="form.division === 'O'">
					<li class="nav-label mg-b-10-f" v-if="i === 0">&nbsp;</li>
					<div class="form-group">
						<label for="formGroupExampleInput" class="d-block has-text-weight-semibold">{{form.name}}</label>
						<p class="mg-b-0 text-left" v-if="form.value.length > 0"><span v-for="(form1, i) in form.value" v-if="form1.codeCode == orderData[form.id]">{{form1.codeName}}</span></p>
						<p class="mg-b-0 text-left" v-else>{{orderData[form.id]}}</p>
					</div>
				</ul>
				<ul class="sidebar-nav" v-for="(form, i) in checkboxSearchForms">
					<div class="form-group">
						<label for="formGroupExampleInput" class=" d-block has-text-weight-semibold">{{form.name}}</label> 
						<div class="ml-2 custom-control custom-radio mb-1" v-for="(form1, i) in form.value">
							<input type="radio" :id="form1.codeCode" :name="form.id" :value="form1.codeCode" v-model="orderData[form.id]" class="custom-control-input" :checked="form1.codeCode == orderData[form.id]">
							<label class="custom-control-label" :for="form1.codeCode">{{form1.codeName}}</label>
						</div>
					</div>
				</ul>
				<ul class="sidebar-nav" v-for="(form, i) in dateSearchForms">
					<div class="form-group">
						<label for="formGroupExampleInput" class="d-block has-text-weight-semibold">{{form.name}}</label>
						<p class="mg-b-0 text-left">{{orderData[form.id]}}</p>
					</div>
				</ul>
			</div><!-- sidebar-body -->
		</div><!-- sidebar -->
		<div class="content content-components">
			<div class="pd-x-0 pd-lg-x-10 pd-xl-x-0">
				<div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
					<div>
						<nav aria-label="breadcrumb">
							<ol class="breadcrumb breadcrumb-style1 mg-b-10">
								<li class="breadcrumb-item">{{this.mainName}}</li>
								<li class="breadcrumb-item" aria-current="page">{{this.subName}}</li>
								<li class="breadcrumb-item active" aria-current="page">View</li>
							</ol>
							<h4 class="mg-b-0 tx-spacing--1">{{this.subName}} View</h4>
						</nav>
					</div>
					<div class="card-header2 col-lg-8 col-xl-7 pd-y-15 pd-x-20 d-flex align-items-center justify-content-end">
						<router-link class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" :to="{name:this.$route.name.replace('_completion',''), params:{mid:this.properties.mid, type:'list'}}"><i data-feather="file" class="wd-10 mg-r-5"></i>list</router-link>
					</div>
				</div>
				<div class=" pd-x-0 pd-lg-x-10 pd-xl-x-0">
					<div class="col-sm-6 col-lg-5">
						<ul class="cardborder nav nav-tabs" id="myTab" role="tablist">
							<li class="nav-item"><a class="nav-link active" id="experiment-tab" data-toggle="tab" href="#experiment" role="tab" aria-controls="experiment" aria-selected="true" @click="">Order</a></li>
							<!-- <li class="nav-item"><a class="nav-link" id="plate-tab" data-toggle="tab" href="#plate" role="tab" aria-controls="plate" aria-selected="false">Plate</a></li> -->
						</ul>
					</div>
					<div class="card card-body">
						<div class="tab-content mg-t-20" id="myTabContent">
							<div class="tab-pane fade lm-overflow show active" id="experiment" role="tabpanel" aria-labelledby="experiment-tab">
								
								<ul class="nav nav-line" id="myTab5" role="tablist">
									<li class="nav-item" v-for="(form, i) in tabHeader" v-if="properties.mid === form.id"><a class="nav-link active" v-on:click='classifySampleHeader(form.id)' :id="form.id" data-toggle="tab" href="#" role="tab" aria-controls="home" aria-selected="true">{{form.menuName}}</a></li>
									<li class="nav-item" v-else><a class="nav-link"  v-on:click='classifySampleHeader(form.id)' :id="form.id" data-toggle="tab" href="#" role="tab" aria-controls="profile" aria-selected="false">{{form.menuName}}</a></li>
								</ul>
								<!-- <hot-table id='sample-table' :settings="sheetSettings" :data="sampleData" class="ht-hot-table" ref="sheet" :afterChange="changeData"></hot-table> -->
                                <div class="card col-lg-8 col-xl-7 mg-b-20 mg-lg-b-25">
                                    <section>
                                        <b-table :data="isEmpty ? [] : sampleData" hoverable striped>
                                            <template slot-scope="props">
                                                <b-table-column v-for="(form, i) in sampleHeader"
                                                  v-if="i == 0"
                                                  :key="i"
                                                  field="No" 
												                          label="No">
                                                  {{ props.row.no }}
                                                </b-table-column>
                                                <b-table-column 
                                                    v-else
                                                    :key="i"
                                                    :field="form.columnCode"
                                                    :label="form.columnName"
                                                    centered >
                                                    {{ props.row[form.columnCode] }}
                                                </b-table-column>
                                            </template>
                                            <template slot="empty">
                                              <section class="section">
                                                <div class="content has-text-grey has-text-centered">
                                                  <p>Nothing here.</p>
                                                </div>
                                              </section>
                                            </template>
                                        </b-table>
                                    </section>
                                </div><!-- card -->
							</div><!-- tab -->
							</div>
							
						</div>
					</div><!-- card -->
				</div>
			</div>
		</div>
	
</template>
<script>
// 공통 함수 관리 파일 임포트
import common from "@/views/Common/common.js";
// 멀티 드래그 앤 드롭 임포트
import { Sortable, MultiDrag, Swap } from "sortablejs";
Sortable.mount(new MultiDrag());
Sortable.mount(new Swap());

// Header의 메뉴 정보 호출을 위한 bus event
import { bus } from "../../main";

export default {
  name: "Detail",
  props: ["properties"],
  data() {
    return {
      mainName: "",
      subName: "",
      menuData: [], // header.vue data

      mid: "", // menu list id
      msid: "", // menu sheet id
      uid: "", // sheet id
      ssid: "", // sample list id
      rowNum: "", // sample group row number

      /* Experiment input Form */
      orderHeader: [], // 입력 값 header column
      inputSearchForms: [], // 입력 input form
      dateSearchForms: [], // 입력 date form
      checkboxSearchForms: [], // 입력 radio form

      /* Experiment 정보 Form Value */
      orderData: [], // 실험 정보 확인
      dafaultorderData: [], // 화면에 처음 접속 시 유지된 실험 정보 (데이터 저장 시 수정 사항 체크에 필요)

      /* tab Header */
      tabHeader: [],

      /* 이전 단계 Sample 정보 */
      preHeader: [],
      preData: [],
      preDefaultData: [],
      preSampleHeader: [],
      preSampleData: [],
      preDefaultSampleData: [],

      checkedRows: [], // 그룹 체크 row 확인
      checkedRowData: [], // add 이전 체크 sample row 확인
      sampleCheckedRows: [], // sample 체크 row 확인
      isEmpty: false,
      addData: [],
      defaultOpenedDetails: [],

      /* Sample Form */
      sampleHeader: [], // Experiment Sample Header
      sampleData: [], // Experiment Sample list data
      // sampleData:[1,2,3,4,5,6,7,8,9,10],

      dafaultSampleData: [], // 화면에 처음 접속 시 유지된 Sample 정보 (데이터 저장 시 수정 사항 체크에 필요)
      //sampleChangeData:[], // Sample의 변경 정보
      boolChange: false, // 데이터 변경 유무 확인

      /* Loading */
      isLoading: false,
      isFullPage: true,

    };
  },
  beforeDestroy() {
    bus.$off("menu_data");
  },
  created() {
    this.openLoading();
    bus.$on("menu_data", data => {
      this.menuData = data;
      this.classifyHeader();
    });
  },
  mounted() {
  },
  methods: {
    /*
     * Load Data Reception Headers
     */
    async classifyHeader() {
        let data = common.menuHeader(this.properties.mid, this.menuData);
            this.mainName = data[0];
            this.subName = data[1];
            this.msid = data[2];
            this.orderHeader = data[3];
            this.tabHeader = common.tabOrder(this.properties.mid, this.menuData);
            this.inputSearchForms = [];
            this.dateSearchForms = [];
            this.checkboxSearchForms = [];
            for(let i in this.orderHeader){
                if(this.orderHeader[i].columnType == "LIST"){
                    if(this.orderHeader[i].columnAttr =='statecode'){
                        this.inputSearchForms.push({'name':this.orderHeader[i].columnName, 'value':this.orderHeader[i].code, 'id':this.orderHeader[i].columnCode ,'division':'O'});
                    }else{
                        this.checkboxSearchForms.push({'name':this.orderHeader[i].columnName, 'id':this.orderHeader[i].columnCode, 'value':this.orderHeader[i].code, 'division':this.orderHeader[i].columnDivision});
                    }
                }else if(this.orderHeader[i].columnType == "DATE"){
                    if(!common.isNull(this.properties.uid)){
                        this.dateSearchForms.push({'name':this.orderHeader[i].columnName, 'value':'', 'id':this.orderHeader[i].columnCode, 'division':this.orderHeader[i].columnDivision});
                    }
                }else if(this.orderHeader[i].columnType == "COUNT"){
                    
                } else {
                    if (this.orderHeader[i].columnName == 'No') {
                    } else {
                        if (!common.isNull(this.properties.uid)) {
                            this.inputSearchForms.push({'name':this.orderHeader[i].columnName, 'value':'', 'id':this.orderHeader[i].columnCode, 'division':this.orderHeader[i].columnDivision});
                        } else {
                            if(this.orderHeader[i].columnDivision == 'C'){
                                this.inputSearchForms.push({'name':this.orderHeader[i].columnName, 'value':'', 'id':this.orderHeader[i].columnCode, 'division':this.orderHeader[i].columnDivision});
                            }
                        }
                    }
                }
            }
        this.classifySampleHeader(this.properties.mid);
    },
    /*
     * Load Headers & Samples Data
     */
    async classifyData() {
        this.sampleData = [];
        var thisData = [];
        var sampleData = [];
        if (!common.isNull(this.properties.uid)) {
            var params = [];
            if (Array.isArray(this.ssid)) {
                this.ssid = this.ssid[0];
            }
            params = { ssid: this.ssid };
            params["uid"] = this.properties.uid;
            var request = { params: params };
            await this.$axios
                .get(this.$apiHost + "/orderconfirms/detail", request)
                .then(res => {
                    this.orderData = res.data;
                })
                .catch(err => {
                    console.log(err);
            });
            sampleData = common.makeData(this.orderData.samples, 1);
            for (let i in sampleData) {
                sampleData[i].no = Number(i) + 1;
                this.sampleData.push(sampleData[i]);
            }
        }
        this.isLoading = false;
    },
    /*
     * First Load Previous Data & Samples Data
     */
    async classifySampleHeader(id) {
      this.sampleHeader = [];
      let thisMid = id.replace(/ /gi, "");
      let parse = [];
      if (common.isNull(thisMid)) thisMid = this.properties.mid;
      let data = common.makeHeader(this.properties.mid, this.menuData, 2);
      this.ssid = data[0];
      parse = data[1];
      parse.forEach((a,b)=>{
        if(Number(b)===0){
          this.sampleHeader = this.sampleHeader.concat({columnCode:'No'});
          this.sampleHeader = this.sampleHeader.concat(a);
        }else{
          if(a.mid === thisMid) this.sampleHeader = this.sampleHeader.concat(a);
          else if (!a.hasOwnProperty('mid')) this.sampleHeader = this.sampleHeader.concat(a);
        }
      });
      this.classifyData();
    },
    /*
     * List page Move (리스트 목록 페이지 이동)
     */
    goPage() {
      if (this.boolChange) {
        var result = confirm("You have changed data. Would you like to leave?");
        if (result) {
          this.$router.push({
            name: this.$route.name.replace("_detail", ""),
            params: { mid: this.properties.mid, type: "list" }
          });
        } else {
          return false;
        }
      } else {
        this.$router.push({
          name: this.$route.name.replace("_detail", ""),
          params: { mid: this.properties.mid, type: "list" }
        });
      }
    },
    /*
     * page Loading bar
     */
    openLoading() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 10 * 100);
    }
  },

  components: {},
  computed: {},
  watch: {}
};

</script>
<style src="../../../node_modules/handsontable/dist/handsontable.full.css"></style>


// WEBPACK FOOTER //
// src/views/OrderConfirmation/CompletionForm.vue